import {
  PluginRunIndividualPlugin,
  PluginRunIndividualPluginResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runIndividualPlugin = (
  constructPost: ConstructPost,
  pluginKey: string,
  data: PluginRunIndividualPlugin,
): Promise<
  NonPaginatedResponse<PluginRunIndividualPluginResponse> | undefined
> =>
  constructPost<NonPaginatedResponse<PluginRunIndividualPluginResponse>>(
    `${PLUGIN_BASE_PATH}/${pluginKey}`,
    { data },
    { preventDefaultErrorToast: true },
  );
